import React, { useState } from 'react';

interface DataEntryTabsProps {
  sectionName: string;
  lmTabContent: React.ReactNode;
  manualTabContent: React.ReactNode;
  lmFieldCount: number;      // Number of filled LM fields
  manualFieldCount: number;   // Number of filled manual fields
}

const DataEntryTabs: React.FC<DataEntryTabsProps> = ({
  sectionName,
  lmTabContent,
  manualTabContent,
  lmFieldCount,
  manualFieldCount
}) => {
  const [activeTab, setActiveTab] = useState<'lm' | 'manual'>('lm'); // LM first (premium data)

  return (
    <div className="space-y-4">
      {/* Tab Headers */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-4" aria-label="Tabs">
          {/* Launch Monitor Tab */}
          <button
            type="button"
            onClick={() => setActiveTab('lm')}
            className={`
              whitespace-nowrap py-3 px-4 border-b-2 font-medium text-sm transition-colors
              ${activeTab === 'lm'
                ? 'border-green-ink text-green-ink'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <span className="flex items-center gap-2">
              📊 Launch Monitor Data
              {lmFieldCount > 0 && (
                <span className={`
                  inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium
                  ${activeTab === 'lm' ? 'bg-green/15 text-green-ink' : 'bg-gray-100 text-gray-600'}
                `}>
                  {lmFieldCount}
                </span>
              )}
            </span>
          </button>

          {/* Manual Entry Tab */}
          <button
            type="button"
            onClick={() => setActiveTab('manual')}
            className={`
              whitespace-nowrap py-3 px-4 border-b-2 font-medium text-sm transition-colors
              ${activeTab === 'manual'
                ? 'border-green-ink text-green-ink'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <span className="flex items-center gap-2">
              ✏️ Manual Entry
              {manualFieldCount > 0 && (
                <span className={`
                  inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium
                  ${activeTab === 'manual' ? 'bg-green/15 text-green-ink' : 'bg-gray-100 text-gray-600'}
                `}>
                  {manualFieldCount}
                </span>
              )}
            </span>
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === 'lm' ? lmTabContent : manualTabContent}
      </div>
    </div>
  );
};

export default DataEntryTabs;
